module.exports = __webpack_public_path__ + "img/png.a77bee4.svg";